import React, { FC } from "react";
import { observer } from "mobx-react";
import PlusIcon from "../../../../../images/products/plus.svg";
import styled from "styled-components";
import NewContactPopup from "./NewContactPopup";
import { ContactReferenceModel } from "../models";
import {
  CustomLabel,
  FlexContainer,
  SingleSelect,
} from "@mindmemobile/mm-shared-global";

type IProps = {
  contacts: ContactReferenceModel[];
  selectedContact?: ContactReferenceModel;
  onSelect: (contact: ContactReferenceModel) => void;
  onRefresh?: (
    contactId: string,
    mindmeContactId: string,
    searchValue: string,
    pageSize: number
  ) => void;
  hasError?: boolean;
  onSearch?: (value: string) => void;
  className?: string;
  hasMoreContacts?: boolean;
};
export const ContactDropdownWrapper = styled.span`
  .contact-dpdn {
    width: 415px;
    .header {
      width: 415px;
      max-width: unset;
    }
    .options-menu {
      width: 415px;
      > div:not(.input-wrapper, .new-payment-option) {
        max-height: 78px;
        padding: 0px 15px;
      }
    }
    .new-payment-option {
      padding: 10px 10px;
      cursor: pointer;
    }
  }
  .options-menu {
  }
`;

const defaultPageSize = 50;
const ContactDropDown: FC<IProps> = ({
  contacts,
  selectedContact,
  onSelect,
  onRefresh,
  hasError,
  className,
  hasMoreContacts,
}) => {
  const [showContactPopup, setShowContactPopup] = React.useState(false);
  const [pageSize, setPageSize] = React.useState(defaultPageSize);

  function onClosePopUp(refresh: boolean, contactId?: string) {
    setShowContactPopup(false);
    if (refresh && contactId) {
      onRefresh && onRefresh(contactId, "", "", pageSize);
    }
  }
  return (
    <ContactDropdownWrapper>
      {showContactPopup && (
        <NewContactPopup
          onClose={(refresh: boolean, contactId?: string) =>
            onClosePopUp(refresh, contactId)
          }
        />
      )}
      <SingleSelect
        hasError={hasError === true}
        selectedKey={""}
        searchKeys={[
          "displayValue",
          "fullName",
          "email",
          "fistName",
          "lastName",
          "homePhone.phoneNumber",
          "workEmail",
          "otherEmail",
          "workPhone.phoneNumber",
          "otherPhone.phoneNumber",
          "mobilePhone.phoneNumber",
        ]}
        options={[contacts]}
        customHeader={
          <FlexContainer spacing={10} alignItems="center">
            {selectedContact?.displayValue || "Select Customer"}
          </FlexContainer>
        }
        customOption={(option: ContactReferenceModel) => (
          <FlexContainer
            padding="0px 0px 5px"
            key={option.displayValue}
            spacing={10}
            alignItems="center"
          >
            {/* <div
                            style={{
                                height: '10px',
                                width: '10px',
                                borderRadius: '50%',
                            }}
                        /> */}
            <FlexContainer fxLayout="column">
              <CustomLabel>{option.displayValue}</CustomLabel>
            </FlexContainer>
          </FlexContainer>
        )}
        className={`dpdn-with-icons contact-dpdn ${className}`}
        searchable={true}
        searchPlaceholder="Search..."
        nameKeys={["fullName"]}
        valueKeys={["value"]}
        onChange={(option: ContactReferenceModel, searchValue?: string) => {
          onSelect(option);
          if (searchValue) {
            onRefresh &&
              onRefresh(
                option.id,
                option.mindmeContactId || "",
                searchValue,
                pageSize
              );
          }
        }}
        footerClass="new-payment-option"
        customFooter={
          <FlexContainer
            alignItems="center"
            onClick={() => {
              setShowContactPopup(true);
            }}
          >
            <img
              src={PlusIcon}
              alt="New Customer"
              style={{ width: "16px", height: "16px" }}
            />
            <span>New Customer</span>
          </FlexContainer>
        }
        hasMoreRecords={hasMoreContacts === true}
        loadData={(searchValue: string) => {
          const newPageSize = pageSize + defaultPageSize;
          setPageSize(newPageSize);
          onRefresh && onRefresh("", "", searchValue, newPageSize);
        }}
        onSearch={(searchValue: string) => {
          setPageSize(defaultPageSize);
          onRefresh && onRefresh("", "", searchValue, pageSize);
        }}
      />
    </ContactDropdownWrapper>
  );
};

export default observer(ContactDropDown);
